import React, { useCallback, useEffect, useState } from 'react'
import ModalWrapper from '../../../components/UI/ModalWrapper'
import { ReactComponent as CloseIcon } from '../../../assets/icons/cross.svg'
import classNames from 'classnames'
import s from './index.module.scss'
import { useActions } from '../../../hooks/useActions'
import Button from '../../../components/UI/Button'
import { IIoTruckNeedFilling } from '../../../models/models'
import { formatPhone } from '../../../helpers'

interface IProps {
	data: IIoTruckNeedFilling
}

const TrucksNotificationModal: React.FC<IProps> = ({ data }) => {
	const { setFillObj, setTruckNeedFilling } = useActions()

	const [isAnimate, setIsAnimate] = useState<boolean>(false)

	const onClose = useCallback(() => {
		setIsAnimate(true)
		setTimeout(() => {
			setTruckNeedFilling(null)
		}, 300)
	}, [])

	const handleClick = () => {
		setFillObj({ type: data.tankType, id: data.tankId })
		onClose()
	}

	useEffect(() => {
		const listener = (event: KeyboardEvent) => {
			if (event.code === 'Escape') {
				onClose()
			}
		}

		document.addEventListener('keydown', listener)
		return () => document.removeEventListener('keydown', listener)
	}, [])

	return (
		<ModalWrapper closeHandler={onClose} isAnimate={isAnimate}>
			<div
				className={classNames(s.wrapper, {
					[s.animate]: isAnimate,
				})}
			>
				<CloseIcon className={s.closeIcon} onClick={onClose} />
				<h3 className={s.title}>
					В {data.tankType === 'truck' ? 'паливовозі' : 'причепі'} залишилось менше {data.minPercent}% пального
				</h3>
				<p className={s.text}>
					Номер {data.tankType === 'truck' ? 'паливовоза' : 'причепа'} <span>{data.tankNumber}</span>
				</p>
				<p className={s.text}>
					ПІБ водія <span>{data.trucker.fullName}</span>
				</p>
				<p className={s.text}>
					Телефон водія <span>{formatPhone(data.trucker.phone) || '-'}</span>
				</p>

				<Button variant="filled" className={s.btn} onClick={handleClick}>
					Обрати місце заправки
				</Button>
			</div>
		</ModalWrapper>
	)
}

export default TrucksNotificationModal
